import { request } from 'umi';
import type { PageParams } from '@/pages/typings';
import type { CustomerQuestionnaireSubjectType } from '@/pages/Assessment/data';

export async function getServiceTaskDetail(params: { id: number } ) {
  return request('/hm/service-task/detail', {
    params
  })
};

export async function getServiceTaskMediaList() {
  return request('/hm/service-task/media-list')
};

export async function saveServiceTask(params: { customerId: string, serviceTaskIds: string }, data: any) {
  return request('/hm/service-task/hold', {
    method: 'POST',
    params,
    data
  })
};

export async function submitServiceTask(params: { serviceTaskIds: string }, data: any) {
  return request('/hm/service-task/submit', {
    method: 'POST',
    params,
    data
  })
};

export async function getServiceTaskRelationList(params: { groupType: string; taskId: number }) {
  return request('/hm/service-task/relation-list', {
    params
  })
};

export async function getServiceTaskLog(params: { taskId: number }) {
  return request('/hm/service-task/taskLog-list', {
    params
  })
};

export async function getRecommendServiceTask(params: { taskId: number } & PageParams) {
  return request('/hm/service-task/recommend-list', {
    params
  })
};

export async function confirmProcessServiceTask(params: { taskIds: string | number }) {
  return request('/hm/service-task/process/confirm', {
    method: 'POST',
    params
  })
};

export async function getQuestionnaireRecordBySubject(params: { customerId: string; subjectId: string; subjectType: CustomerQuestionnaireSubjectType }) {
  return request('/hm/questionnaire/record/subject', {
    params
  })
};

export async function batchGetCustomerMetricById(params: { ids: string, withLabel?: boolean }) {
  const { ids, ...otherParmas } = params;
  return request(`/core/customer/metrics/get/batch/${ids}`, {
    params: otherParmas
  })
};

/** core--客户账号接口--判断客户及亲友是否关注公众号，有一人关注则返回true，否则返回false
 * @method GET
 * @url /core/customer/account/subscribedWxMp
 * @param {String} customerId   *客户id
 */
export async function fetchWeChatSubscriptionStatus(params: { customerId: string }) {
  return request('/core/customer/account/subscribedWxMp', { params })
}
